export default function readMore() {
    /**
     * Text Read More / Less with slide effect only for mobile.
     */
    // JS Media query
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const container = document.querySelector('.read-more-container');
    if (container) {
        const button = document.querySelector('.read-more-toggle');
        const openText = button.dataset.openText;
        const closeText = button.dataset.closeText;
        const content = container.querySelector('.content');
        let heightOriginal = content.clientHeight + 'px';
        let heightReduced = container.dataset.startingHeight + 'px';

        handleMediaQueryChange(mediaQuery);

        // On resize event with debounce recalculate
        let resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                heightOriginal = content.clientHeight + 'px';
                handleMediaQueryChange(mediaQuery);
            }, 250);
        });

        function handleMediaQueryChange(mediaQuery) {
            if (mediaQuery.matches) {
                container.style.height = heightReduced;
                container.classList.remove('active');

                button.addEventListener('click', toggleReadMore);
            } else {
                container.style.height = 'auto';
                container.classList.remove('active');
                // Remove event listener to avoid events stacking up
                button.removeEventListener('click', toggleReadMore);
            }
        }

        function toggleReadMore() {
            /** Slide down. */
            if (!container.classList.contains('active')) {
                container.classList.add('active');
                container.style.height = heightOriginal;
                button.textContent = closeText;
                /** Slide up. */
            } else {
                container.style.height = heightReduced;
                button.textContent = openText;
                container.addEventListener(
                    'transitionend',
                    () => {
                        container.classList.remove('active');
                    },
                    { once: true }
                );
            }
        }
    }

    /**
     * Boxes Read More
     */
    const readToggleBtns = document.querySelectorAll('.read-toggle-btn');
    const bodyGradient = document.querySelector('.body-gradient-start');

    for (const btn of readToggleBtns) {
        btn.addEventListener('click', function (e) {
            const openText = this.dataset.openText;
            const closeText = this.dataset.closeText;

            this.classList.toggle('show');
            this.textContent = this.classList.contains('show')
                ? closeText
                : openText;

            this.previousElementSibling.classList.toggle('show');

            // Update the body gradient bottom position at the end of transition
            this.previousElementSibling.addEventListener(
                'transitionend',
                function () {
                    // Update body the gradient bottom position
                    const gradientStart = bodyGradient.offsetTop;
                    const gradientStartOffset = parseInt(
                        getComputedStyle(bodyGradient).getPropertyValue(
                            '--gradient-start-offset'
                        )
                    );
                    // get body element height
                    const docHeight = document.body.offsetHeight;
                    let height = docHeight - gradientStart;
                    height -= gradientStartOffset;

                    bodyGradient.style.setProperty(
                        '--gradient-bottom-position',
                        height + 'px'
                    );
                },
                { once: true }
            );
        });
    }

    // Check if MatchHeight is enabled and then initialize it
    // Used on column independent readm more slide.
    if (typeof MatchHeight !== 'undefined') {
        setTimeout(() => {
            new MatchHeight();
        }, 500);
    }
}
